import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {StructureBuiltInControl} from '../StructureBuiltInControl';

export abstract class StructureMarginsBuiltInControl extends StructureBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.STRUCTURE].EXTERNAL_INDENTS;
  }
}
